export default __webpack_public_path__ + "static/media/video3.8e11313d.mp4";